
import Box from '@mui/material/Box';
import CustomAvatar from '../../component/CustomAvatar';
import { FanDataType } from './creatorFanData';
import { memo, useEffect, useRef, useState } from 'react';
import { USER_TYPE } from '../../config/const';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';

interface CreatorFanData {
  fanData: FanDataType;
}

function CreatorFanList(props: CreatorFanData) {
  const { fanData } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [maxVisibleFans, setMaxVisibleFans] = useState<number>(0);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const avatarWidth = 49;
        const maxFans = Math.floor(containerWidth / avatarWidth);
        if (fanData.fans.length > maxFans) {
          setMaxVisibleFans(maxFans-1);
        } else {
          setMaxVisibleFans(maxFans);
        }
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      ref={containerRef}
      display="flex"
      textAlign="center"
      justifyContent="flex-start"
      width="100%"
      overflow="hidden"
      whiteSpace="nowrap"
      flexWrap="nowrap"
    >
      {fanData?.fans?.slice(0, maxVisibleFans).map((fanItem) => (
        <Box
          key={fanItem?.user_id}
          m={1}
          flexDirection="column"
          display="flex"
          alignItems="center"
          sx={{ margin: '0px 9px 0px 0px', paddingTop: 1.5 }}
        >
          {
            fanItem?.user_type === USER_TYPE.CREATOR ?
              <IconButton
                href={`/${fanItem?.user_name || ''}`}
                sx={{
                  p: 0,
                }}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  navigate(`/${fanItem?.user_name || ''}`)
                }}
              >
                <CustomAvatar
                  src={fanItem?.profile_pic_url}
                  alt={fanItem?.full_name}
                  sx={{
                    mb: 0.8,
                    width: 40,
                    height: 40,
                    fontSize: '2.1875rem',
                  }}
                >
                  {fanItem?.full_name ? fanItem.full_name[0] : ''}
                </CustomAvatar>
              </IconButton> :
              <CustomAvatar
                src={fanItem?.profile_pic_url}
                alt={fanItem?.full_name}
                sx={{
                  mb: 0.8,
                  width: 40,
                  height: 40,
                  fontSize: '2.1875rem',
                }}
              >
                {fanItem?.full_name ? fanItem.full_name[0] : ''}
              </CustomAvatar>
          }

        </Box>
      ))}
      {fanData.total_fans > Math.min(maxVisibleFans, fanData?.fans?.length) && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            marginTop: 1.5,
            backgroundColor: '#424242',
            color: '#fff',
            borderRadius: '50%',
            width: 40,
            height: 40,
            fontSize: '1rem',
            textAlign: 'center',
            flexShrink: 0,
          }}
        >
          +{fanData.total_fans - Math.min(maxVisibleFans, fanData?.fans?.length)}
        </Box>
      )}
    </Box>
  );
}

export default memo(CreatorFanList);
